import { Container, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../../../../common/GameFont";
import { StringFormatExtention } from "../../../../../../extensions/StringFormatExtention";

export class RewardContainer extends Container {
    private static readonly DICE_ROLLS_TEXT = "DICE ROLLS";

    public constructor(iconTexture: Texture, value: number) {
        super();
        this.build(iconTexture, value);
    }

    private build(iconTexture: Texture, value: number): void {
        const rewardIcon = new Sprite(iconTexture);
        rewardIcon.anchor.set(0.5, 0.5);
        rewardIcon.position.set(rewardIcon.width * 0.06, -rewardIcon.height * 0.2);
        this.addChild(rewardIcon);
        const diceRollsValueText = new Text(`X${StringFormatExtention.formatWithComma(value)}`, new DiceRollsValueTextStyle());
        diceRollsValueText.anchor.set(0.5, 0.5);
        diceRollsValueText.y = diceRollsValueText.height * 0.3;
        this.addChild(diceRollsValueText);
        const diceRollsText = new Text(RewardContainer.DICE_ROLLS_TEXT, new DiceRollsTextStyle());
        diceRollsText.anchor.set(0.5, 0.5);
        diceRollsText.position.set(diceRollsValueText.x, diceRollsValueText.y + diceRollsValueText.height * 0.5);
        this.addChild(diceRollsText);
    }
}

class DiceRollsTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: [
                "#feca3b",
                "#f49801"
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 59,
            stroke: "#ffffff",
            strokeThickness: 10
        }));
    }
}

class DiceRollsValueTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: [
                "#feca3b",
                "#f49801"
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 170,
            stroke: "#ffffff",
            letterSpacing: -3,
            strokeThickness: 10
        }));
    }
}
